export default {
    NUMBER: "number",
    STRING: "string",
    DATE: "date",
    MONTH: "month",
    WEEK_DAY: "weekDay",
    WEIGHT: "weight",
};
